import React from "react";

/**
 * LocalRida wordmark logo — light + dark variants.
 * Colors from spec:
 *   Light: navy #0B1F2F, gold #B8892A, teal #077877
 *   Dark:  offwhite #F7F3EE, gold #C6932E, teal #078686
 */
export function LogoLight({ className = "", showTagline = true }) {
  return (
    <div className={`inline-flex items-baseline gap-2 ${className}`} data-testid="logo-light">
      <div className="flex items-baseline">
        <span className="font-display text-3xl sm:text-4xl font-medium text-navy leading-none">Local</span>
        <span className="font-display text-3xl sm:text-4xl font-medium text-gold leading-none">Rida</span>
        <span className="ml-1 h-2 w-2 bg-teal inline-block" aria-hidden />
      </div>
      {showTagline && (
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-navy/60 font-sans">
          Private Transfers
        </span>
      )}
    </div>
  );
}

export function LogoDark({ className = "", showTagline = true }) {
  return (
    <div className={`inline-flex items-baseline gap-2 ${className}`} data-testid="logo-dark">
      <div className="flex items-baseline">
        <span className="font-display text-3xl sm:text-4xl font-medium text-offwhite leading-none">Local</span>
        <span className="font-display text-3xl sm:text-4xl font-medium text-gold-bright leading-none">Rida</span>
        <span className="ml-1 h-2 w-2 bg-teal-bright inline-block" aria-hidden />
      </div>
      {showTagline && (
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-offwhite/60 font-sans">
          Private Transfers
        </span>
      )}
    </div>
  );
}
